"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _ossUpload = require("@/utils/ossUpload");
var _customPage = require("@/api/customPage");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: ['pageId', 'type'],
  data: function data() {
    return {
      id: '',
      dialogVisible: false,
      ruleForm: {
        bgColor: '',
        bgPic: '',
        refreshBackgroundColor: '',
        navbarStatus: ''
      },
      rules: {
        refreshBackgroundColor: [{
          required: false
        }],
        navbarStatus: [{
          required: false
        }],
        bgColor: [{
          required: false
        }],
        bgPic: [{
          required: false
        }]
      }
    };
  },
  methods: {
    delPic: function delPic() {
      this.ruleForm.bgPic = '';
    },
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(_ref) {
        var file, pictureUrl, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = _ref.file;
              _context.p = 1;
              _context.n = 2;
              return (0, _ossUpload.uploadOSS)(file);
            case 2:
              pictureUrl = _context.v;
              // console.log(pictureUrl, '-------------')
              this.ruleForm.bgPic = pictureUrl;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.log('error ->', _t);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function handleFileUpload(_x) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    open: function open(data) {
      console.log(data);
      this.ruleForm.bgPic = data.backgroundUrl;
      this.ruleForm.bgColor = data.color;
      this.ruleForm.navbarStatus = data.navbarStatus;
      this.ruleForm.refreshBackgroundColor = data.refreshBackgroundColor;
      this.dialogVisible = true;
      console.log(this.$props.pageId);
    },
    onClose: function onClose() {
      this.ruleForm = {
        navbarStatus: '',
        bgColor: '',
        bgPic: '',
        refreshBackgroundColor: ''
      };
      this.$refs['ruleForm'].resetFields();
      this.dialogVisible = false;
    },
    submitForm: function submitForm(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          (0, _customPage.updateColor)({
            pageId: _this.$props.pageId,
            type: _this.$props.type,
            color: _this.ruleForm.bgColor,
            backgroundUrl: _this.ruleForm.bgPic,
            navbarStatus: _this.ruleForm.navbarStatus,
            refreshBackgroundColor: _this.ruleForm.refreshBackgroundColor
          }).then(function (res) {
            if (res.data) {
              _this.$notify.success({
                title: '温馨提示',
                message: '操作成功'
              });
              _this.$emit('refresh');
              _this.onClose();
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};